import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "description", "metadata", "icon", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { IconPredefined } from '@snack-uikit/icon-predefined';
import { Typography } from '@snack-uikit/typography';
import { excludeSupportProps } from '@snack-uikit/utils';
import { parseKeyToDataTest } from '../../../utils';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PrivateCardHeader(_ref) {
  var title = _ref.title,
    description = _ref.description,
    metadata = _ref.metadata,
    icon = _ref.icon,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: cn(styles.titleLayout, className)
  }, excludeSupportProps(rest)), {}, {
    children: [icon && /*#__PURE__*/_jsx(IconPredefined, {
      icon: icon,
      size: "s",
      decor: false,
      appearance: "neutral",
      shape: "square"
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.contentLayout,
      children: [/*#__PURE__*/_jsx(Typography, {
        family: "sans",
        size: "s",
        purpose: "title",
        className: styles.title,
        "data-test-id": parseKeyToDataTest('catalog-card', 'title'),
        children: title
      }), metadata && /*#__PURE__*/_jsx(Typography.SansBodyS, {
        className: styles.metadata,
        children: metadata
      }), description && /*#__PURE__*/_jsx(Typography, {
        family: "sans",
        size: "m",
        purpose: "body",
        className: styles.description,
        "data-test-id": parseKeyToDataTest('catalog-card', 'desc'),
        children: description
      })]
    })]
  }));
}